<template>
  <modal ref="modal">
    <modal-body :message="modalMessage" />
    <modal-footer>
      <freeze-button @click="doFreeze" />
      <cancel-button data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from "@/views/atoms/Modal";
import ModalBody from "@/views/atoms/ModalBody";
import ModalFooter from "@/views/atoms/ModalFooter";
import FreezeButton from '@/views/molecules/buttons/FreezeButton';
import CancelButton from '@/views/molecules/buttons/CancelButton';

export default {
  name: "FreezeConfirmModal",
  emits: ['freeze'],
  props: {
    message: {
      type: String,
      default: "利用停止してよろしいですか？",
    },
    isDirty: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Modal,
    ModalBody,
    ModalFooter,
    FreezeButton,
    CancelButton,
  },
  computed: {
    modalMessage() {
      return this.message + (this.isDirty ? '\n\n編集中の内容は破棄されます。' : '');
    }
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    doFreeze() {
      this.$refs.modal.hide();
      this.$emit('freeze');
    },
  },
}
</script>
